import { render, staticRenderFns } from "./addProxyFee.vue?vue&type=template&id=0e99fffa&scoped=true"
import script from "./addProxyFee.vue?vue&type=script&lang=js"
export * from "./addProxyFee.vue?vue&type=script&lang=js"
import style0 from "./addProxyFee.vue?vue&type=style&index=0&id=0e99fffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e99fffa",
  null
  
)

export default component.exports